import { createClient } from '@supabase/supabase-js';

// Check for environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials. Check your .env file.');
}

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
});

// Check for the existence of required buckets
const checkStorageBuckets = async () => {
  try {
    // First try direct bucket access, which is more reliable for client-side checks
    try {
      const { error: directError } = await supabase.storage
        .from('pitch_deck_assets')
        .list();
        
      if (!directError) {
        console.log('Successfully connected to the pitch_deck_assets bucket');
        console.log('Bucket is ready for file operations');
        return; // Exit early since we confirmed bucket access works
      } 
    } catch (directErr) {
      console.error('Error testing direct bucket access:', directErr);
    }
    
    // If direct access failed, try listing buckets as a fallback
    const { data: buckets, error: bucketsError } = await supabase.storage.listBuckets();
    
    if (!bucketsError && buckets) {
      // Check for both buckets since we're in a transition period
      const pitchDeckAssetsBucketExists = buckets.some(
        bucket => bucket.name.toLowerCase() === 'pitch_deck_assets'
      );
      
      const pitchDecksBucketExists = buckets.some(
        bucket => bucket.name.toLowerCase() === 'pitch_decks'
      );
      
      if (pitchDeckAssetsBucketExists) {
        console.log('Successfully connected to the pitch_deck_assets bucket');
        console.log('Bucket is ready for file operations');
      } else if (pitchDecksBucketExists) {
        console.log('Successfully connected to the pitch_decks bucket');
        console.log('Bucket is ready for file operations');
      } else {
        console.error(
          'STORAGE ACCESS ISSUE: Unable to access the required storage buckets. ' +
          'Please ensure that the necessary buckets (pitch_decks or pitch_deck_assets) exist in your Supabase instance.'
        );
      }
    } else {
      console.error('Error listing buckets:', bucketsError);
      
      // Additional troubleshooting
      const hasBucket = buckets && buckets.some(
        bucket => bucket.name.toLowerCase() === 'pitch_deck_assets' || bucket.name.toLowerCase() === 'pitch_decks'
      );
      
      if (hasBucket) {
        console.warn(
          'The storage buckets exist but may have permission issues. ' +
          'Please check your Row Level Security policies.'
        );
      } else {
        console.error(
          'Required storage buckets do not exist in your Supabase instance. ' +
          'Please create the necessary buckets following the setup guide.'
        );
      }
    }
  } catch (err) {
    console.error('Unexpected error checking storage buckets:', err);
  }
};

// Call the function when the app initializes
checkStorageBuckets();

export default supabase; 